import React from 'react';

const TateLyleTitle = ({ eventId, children }) => (
  eventId === '6ad8939fe50bec7a2ac8fa23' ? (
    <>
      Tate &amp; Lyle Presentation of Results<br />
      for the Six Months to 30 September 2026
    </>
  ) : children
);

export default TateLyleTitle;
